<template>
  <div>
    <div class="icon-close">
      <b-icon stacked icon="x" @click="closeDialog()" scale="1.1" class="style-x" v-b-tooltip.hover title="Fechar" ></b-icon>
    </div>
    <div class="wrapper-signup">
      <form class="form_signup">
        <p class="tit_card">{{$t('novocadastro')}}</p>

          <b-form-group :label="$t('name')">
            <b-form-input
                    id="input-1"
                    v-model="name"
                    required
            ></b-form-input>
          </b-form-group>

          <b-form-group :label="$t('email')">
            <b-form-input
                    id="input-2"
                    v-model="email"
                    type="email"
                    required
            ></b-form-input>
          </b-form-group>

          <b-form-group :label="$t('password')">
            <b-form-input
                    id="input-3"
                    v-model="password"
                    type="password"
                    required
            ></b-form-input>
          </b-form-group>


          <b-form-group :label="$t('confirm_password')">
            <b-form-input
                    id="input-4"
                    v-model="confirmPassword"
                    type="password"
                    required
            ></b-form-input>
          </b-form-group>
          
          

          <div class="d-flex flex-row-reverse">
            <b-button @click="register()" class="btn_1">
              {{$t('btn_registrarse')}}
              <b-spinner  v-if="showSpinner" variant="light" small></b-spinner>
            </b-button>
          </div>

      </form>
      
      <md-dialog :md-active.sync="showDialog" class="confirmDialog">
        <md-dialog-title>{{$t('new_register')}}</md-dialog-title>
        <div class="box-message-dialog">
          <span> {{ this.msgInfo }} </span>
          <md-icon class="md-size-2x" v-bind:class="{ 'check-nok' : erro , 'check-ok' : !erro }" >{{icon}}</md-icon>
        </div>
        <md-dialog-actions> 
          <md-button class="md-primary" @click="closeDialogConfirm(user.id)">OK</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import firebase from '@/firebaseInit.js';
import i18n from '@/i18n.js'
import store from "@/store"
import functionsSharedMixins from '@/shared/functionsSharedMixin';

export default {
  mixins: [functionsSharedMixins],
  name: 'signup',
  data: () => ({
    
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    showDialog: false,
    msgInfo: '',
    erro: false,
    icon:'',
    user:'',
    refUsers: firebase.firestore().collection('users'),
    showSpinner : false,
  }),
  methods: {
    register: function(){
        this.erro = false;
        this.msgInfo = '';
        this.icon= '';
        this.showDialog = false;

        if(this.nome == '' || this.email == ''  || this.password == '' || this.confirmPassword == '') {
            this.erro = true;
            this.msgInfo = i18n.t('message_error_fields'); 
            this.icon = 'error';
            this.showDialog = true;

        }else if(this.password != this.confirmPassword ){
            this.confirmPassword= '';
            this.password= '';
            this.erro = true;
            this.msgInfo = i18n.t('message_error_doesnt_match_email_and_pwd'); 
            this.icon = 'error';
            this.showDialog = true;
        }
        else{
             this.showSpinner = true;
              firebase
              .auth()
              .createUserWithEmailAndPassword(this.email, this.password)
              .then((data) => {
                data.user.updateProfile({displayName: this.name}).then(() => {
                  this.msgInfo = i18n.t('account_created_succefully');
                  this.icon = 'check_circle_outline'
                  this.showDialog = true;                      
                  this.refUsers.doc(data.user.uid).set({name:this.name, email:this.email, datePrivacyPolicy:null}) ; 
              
                  this.user = {
                    id                : data.user.uid,
                    displayName       : data.user.displayName,
                    email             : data.user.email,
                    datePrivacyPolicy : null
                  }

                });
              },  
              err => {
                  this.erro = true
                  this.msgInfo = i18n.t('message_error_invalid_email_and_pwd');
                  this.icon = 'error';
                  this.showDialog = true;
              })
        }
    },
    closeDialogConfirm: function(){
        this.showDialog = false;
        if(!this.erro){
          this.$emit('showDialogSignUp', false );
          
          this.verifyPrivacyPolicyRead(this.user.id);  
          
          store.commit('SET_USER', this.user );
        }
    },
    
    closeDialog: function(){
      this.$emit('showDialogSignUp', false );
    }
  }
}
</script>

<style lang="scss" scoped>

.wrapper-signup {
    height: 530px;
    color:#fff;  

  .form_signup {
  
    padding: 20px 25px 30px 25px;

    .tit_card{
      font-size: 27px;
      font-family: Roboto;
      font-weight: 100;
      line-height: 36px;
      width: 390px;
      margin-right: 10px;

      padding-right: 40px;
  
    }

    .erro-msg{
      font-size: 14px;
      font-weight: bold;
      color: #ea0000 !important;
    }

  }


 

}

</style>
